// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import FeaturesRankPlatinum from '../_raw/features/icon_features_rank_platinum.svg';

export default withIconProps(FeaturesRankPlatinum, { shouldSetDefaultSize: false });
